import React from 'react';
import { observer } from 'mobx-react';
import { DateTimePicker } from 'react-widgets';
import 'react-widgets/dist/css/react-widgets.css';

export default observer(({ field }) => (
    <div className="form-field" id={"form-input-" + field.id}>
        <div className="form-field-title">
            <label
                htmlFor={field.id}
                className="f7 db mb2 mt3 light-silver"
            >
                {field.label}
            </label>
        </div ><div className="form-field-input" >
            <DateTimePicker
                min={field.extra && field.extra.min}
                id={field.id}
                value={field.value}
                onChange={field.sync}
                time={true}
            />
        </div>
    </div>
));



// WEBPACK FOOTER //
// ./src/components/forms/inputs/WidgetDateTimePicker.jsx